<!-- CheckboxSwitch.vue -->
<script lang="ts" setup>
    import { ref, onMounted, reactive, onBeforeMount, watch, nextTick } from 'vue'; 
import { randomId } from '../../lib/ChoiceUtils';

    const props = withDefaults(defineProps<{  
        modelValue?: boolean,
        disabled?: boolean
        defaultMessage?: string,     // Message when value is false/undefined -- TODO: Change to: uncheckedMessage
        switchedMessage?: string,    // Message when value is true -- TODO: Change to: checkedMessage
        beforeChange?: (newVal:boolean) => Promise<boolean> // Method that allows to to verify a state change should take place
    }>(),
    {
        disabled: false,
        defaultMessage: "Off",
        switchedMessage: "On"
    });

    const emit = defineEmits<{
        "update:modelValue": [value:boolean]
    }>();

    const checkboxId = randomId();

    const compData = reactive<{
        checkBoxValue?: boolean
    }>({});

    onBeforeMount(() => 
        compData.checkBoxValue = props.modelValue ?? false
    );    

    watch(() => props.modelValue, (newVal, _oldVal) => {
        compData.checkBoxValue = newVal ?? false;
    });
 
    async function onChange(evt: Event)
    {     
        const checkBoxEle = (evt.target as HTMLInputElement);

        // Verify we want to change the value
        if (checkBoxEle.checked != props.modelValue)
        {
            if (props.beforeChange)            
            {
                if (!await props.beforeChange(checkBoxEle.checked))
                {
                    checkBoxEle.checked = props.modelValue;
                    return;
                }
            }

            // Indicate the value changed
            emit("update:modelValue", checkBoxEle.checked);
        }
    };

</script>

<template> 
    <div class="form-check form-switch">
        <input ref="checkbox" class="form-check-input" :disabled="props.disabled" :checked="compData.checkBoxValue" type="checkbox" :id="checkboxId" @input="onChange" >

        <slot name="suffix" :value="props.modelValue" :checkboxId="checkboxId">
            <label class="form-check-label" :for="checkboxId">
                <template v-if="props.modelValue">
                    <slot name="checked">
                        {{ props.switchedMessage }}    
                    </slot>
                </template>
                <template v-if="!props.modelValue">
                    <slot name="unchecked">
                        {{ props.defaultMessage }}
                    </slot>
                </template>
            </label>
        </slot>
    </div>
</template>